import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import {
  logoutUser,
  refreshToken,
  setCurrentUser,
} from "../../actions/authActions";
import Modal from "react-modal";
import axios from "axios";
import { Link, withRouter } from "react-router-dom";
import * as myConstList from "../../BaseUrl";
import moment from "moment";
import socketIOClient from "socket.io-client";
import jwt_decode from "jwt-decode";
import $ from "jquery";
import setAuthToken from "../../utils/setAuthToken";
import store from "../../store";
const baseUrl = myConstList.baseUrl;
const baseurlMain = myConstList.baseurlMain;
const jwtToken = localStorage.getItem("jwtToken");
const callBackBaseUrl = myConstList.callBackBaseUrl;
const callLogoutUrl = myConstList.callLogoutUrl;
const source = localStorage.getItem("source");
const theme = localStorage.getItem("theme");
const config = {
  headers: {
    Authorization: "Bearer " + `${localStorage.getItem("jwtToken")}`,
  },
};
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};
//   Modal.setAppElement('#yourAppElement');
class Navbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      balance: 0,
      bonus: 0,
      virtualFund: this.props.virtualFund,
      Rebalance: 0,
      videoStatus: "",
      // PortfolioValue:0,
      winningamount: 0,
      contestId: this.props.match.params.id,
      ex_symbol: this.props.match.params.symbol,
      portfoliototal: this.props.portfoliototal,
      openBuyOrderValue: 0,
      virtualFundassign: this.props.virtualFundassign,
      contestType: this.props.contestType,
      endDate: "",
      endTime: "",
      days: undefined,
      hours: undefined,
      minutes: undefined,
      seconds: undefined,
      modalOnOff: "0",
      symbol: "",
      userPortfolioPercent: 0,
      userPortfolioAmt: 0,
      navShow: "",
      appview: true,
      urltemp: "",
      account: "",
      transaction: "",
    };

    if (
      this.props.portfoliototal === undefined ||
      this.props.portfoliototal == ""
    ) {
      this.setState({
        portfoliototal: 0,
      });
    } else {
      this.setState({
        portfoliototal: this.props.portfoliototal,
      });
    }
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.getData = this.getData.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (jwtToken) {
      const token = jwtToken;
      // setAuthToken(token);
      const decoded = jwt_decode(token);
      const currentTime = Date.now() / 1000;
      if (decoded.exp < currentTime) {
        //     console.log("res.data.data==expire",decoded);
        window.location.reload(false);
      }
    }
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }

    if (nextProps.serverTime) {
      this.setState({
        serverTime: nextProps.serverTime,
      });
    }

    if (nextProps.contestProfolioByUserData) {
      if (nextProps.contestProfolioByUserData.status === true) {
        var gainProfitLoss = 0;
        if (
          nextProps.contestProfolioByUserData.data.portfoliovalue >
          nextProps.contestProfolioByUserData.data.contest_virtualFund
        ) {
          gainProfitLoss =
            nextProps.contestProfolioByUserData.data.portfoliovalue -
            nextProps.contestProfolioByUserData.data.contest_virtualFund;
        }
        if (
          nextProps.contestProfolioByUserData.data.portfoliovalue <
          nextProps.contestProfolioByUserData.data.contest_virtualFund
        ) {
          if (nextProps.contestProfolioByUserData.data.portfoliovalue === 0) {
            gainProfitLoss =
              nextProps.contestProfolioByUserData.data.portfoliovalue;
          } else {
            gainProfitLoss =
              nextProps.contestProfolioByUserData.data.portfoliovalue -
              nextProps.contestProfolioByUserData.data.contest_virtualFund;
          }

          // console.log("portfolioData====",gainProfitLoss);
        }
        // this.setState({
        //   userPortfolioPercent: nextProps.contestProfolioByUserData.data.per.toFixed(3),
        //   userPortfolioAmt: nextProps.contestProfolioByUserData.data.portfoliovalue
        // });
        // console.log("gainProfitLoss==",gainProfitLoss,nextProps.contestProfolioByUserData.data.portfoliovalue);
        this.setState({
          userPortfolioPercent: gainProfitLoss.toFixed(2),
          userPortfolioAmt:
            nextProps.contestProfolioByUserData.data.portfoliovalue,
        });
      }
    }

    if (nextProps.virtualFund) {
      this.setState({
        virtualFund: nextProps.virtualFund,
      });
    }
    // console.log("this.props.portfoliototal==",nextProps.portfoliototal);
    if (nextProps.portfoliototal) {
      this.setState({
        portfoliototal:
          nextProps.portfoliototal !== undefined ? nextProps.portfoliototal : 0,
      });
    }
    if (nextProps.virtualFundassign) {
      this.setState({
        virtualFundassign: nextProps.virtualFundassign,
      });
    }

    if (
      nextProps.orderdata != undefined &&
      nextProps.orderdata.order != undefined &&
      nextProps.orderdata.order.data != undefined &&
      nextProps.orderdata.order.data.message1 != undefined &&
      nextProps.orderdata.order.data.success
    ) {
    }

    if (nextProps.endDate != undefined) {
      this.setState({
        endTime: nextProps.endTime,
        endDate: nextProps.endDate,
      });

      var expriryDateTime1 = this.state.endDate;
      expriryDateTime1 = moment(expriryDateTime1).format("YYYY-MM-DD HH:mm");
      this.setState({ expriryDateTime: expriryDateTime1 });
    }

    // if(nextProps.thirdPhaseConfig !=undefined){
    //   this.setState({account:nextProps.thirdPhaseConfig.account,transaction:nextProps.thirdPhaseConfig.transaction})
    // }
    // this.getData()
  }

  getPortfolioData = () => {
    // timer set
    var expriry = new Date(this.state.expriryDateTime);
    // var today = new Date();
    // var timeComplete = moment().utcOffset('+05:30').format('HH:mm:ss');
    // var currentDate1 = ("0" + (today.getUTCDate())).slice(-2);
    // var dateformat = today.getUTCFullYear()+'-'+(today.getUTCMonth()+1)+'-'+currentDate1+" "+timeComplete;
    var dateformat = this.state.serverTime;
    var currentDate = new Date(dateformat);

    expriry = Date.parse(expriry);
    expriry = expriry / 1000;
    currentDate = Date.parse(currentDate);
    currentDate = currentDate / 1000;
    const countdown = moment(expriry - currentDate);
    var duration = moment.duration(countdown * 1000, "milliseconds");
    var interval = 1000;
    duration = moment.duration(duration - interval, "milliseconds");

    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();
    const symbol1 = this.props.symbol;
    this.setState({ days, hours, minutes, seconds });
    if (seconds <= 0) {
      clearInterval(interval);
    }
    if (
      days <= 0 &&
      minutes <= 0 &&
      hours <= 0 &&
      seconds <= 0 &&
      this.state.modalOnOff == "0"
    ) {
      this.state.modalOnOff = "1";
      // timeout process API
      // console.log("this.state.contestId=",this.state.contestId);
      var collectThis = this;
      const socket = socketIOClient(baseUrl, {
        query: "jwtToken=" + jwtToken + "&contestId=" + this.state.contestId,
      });

      this.setState({ socketCollect: socket });
      // socket.on("connect", () => {
      // console.log("dashboardSocket==");
      collectThis.setState({ currentSocketId: socket.id });
      socket.emit("timeOutProcess");
      // });
      //
      this.openTimerModal();
      setTimeout(function () {
        // window.location.href = window.location.pathname;
        window.location.href = "/dashboard" + collectThis.state.urltemp;
      }, 3000);
    }
    // timer end
  };

  // contestProfolioByUser=()=>{
  //   axios
  //     .post(baseUrl+"api/contestProfolioByUser", {contestId: this.state.contestId},config)
  //     .then(res => {
  //         if(res.data.status===true){
  //           this.setState({userPortfolioPercent:res.data.data.per.toFixed(3),
  //           userPortfolioAmt:res.data.data.portfoliovalue})
  //         }
  //         var classThis = this;
  //         setTimeout(function(){ classThis.contestProfolioByUser(); },1000);
  //     })
  //     .catch()

  // }

  componentDidMount() {
    // if (jwtToken) {
    //   const token = jwtToken;
    //   setAuthToken(token);
    //   const decoded = jwt_decode(token);
    //   store.dispatch(setCurrentUser(decoded));
    //   const currentTime = Date.now() / 1000;
    //   if (decoded.exp < currentTime) {
    //       console.log("res.data.data",decoded);
    //       store.dispatch(refreshToken(decoded.id));

    //   }
    // }
    const socket = socketIOClient(baseUrl, { query: "jwtToken=" + jwtToken });
    var collectThis = this;
    socket.on("connect", () => {
      socket.emit("config3rdphase");
    });
    socket.on("3rdPhaseConfig", function (apiRespData) {
      collectThis.setState({
        account: apiRespData.data[0].account,
        transaction: apiRespData.data[0].transaction,
      });
    });
    if (
      localStorage.getItem("source") !== "" &&
      localStorage.getItem("theme") !== ""
    ) {
      const urltemp =
        "?source=" +
        localStorage.getItem("source") +
        "&theme=" +
        localStorage.getItem("theme");
      this.setState({ urltemp: urltemp });
    }
    const str = window.location.pathname;
    const params = new Proxy(
      new URLSearchParams(this.props.history.location.search),
      {
        get: (searchParams, prop) => searchParams.get(prop),
      }
    );
    let source = params.source;
    let theme = params.theme;
    if (source === "mobile") {
      this.setState({ appview: false });
    }
    if (source === "mobile" && theme === "d") {
      $("body").addClass("darkclass");
    } else {
      $("body").removeClass("darkclass");
    }
    if (str.includes("exchange")) {
      this.setState({ navShow: true });
    }

    //this.contestProfolioByUser();
    // if (this.state.contestId && this.state.ex_symbol) {
    //   this.intervalExchnge = setInterval(() => {
    //     this.getPortfolioData();
    //   }, 1000);
    // } else {
    //   clearInterval(this.intervalExchnge);
    // }

    axios
      .post(baseUrl + "api/profile-data", {}, config)
      .then((res) => {
        // if(res.data.data.videoStatus!="verify" && this.props.urlPath!=false){
        //    this.setState({modalIsOpen: true});
        // }

        this.setState({
          winningamount: res.data.data.winningamount,
          bonus: res.data.data.bonus,
          balance: res.data.data.balance,
          Rebalance: res.data.data.Rebalance,
          videoStatus: res.data.data.videoStatus,
        });
      })
      .catch();
    if (this.state.contestId && this.state.ex_symbol) {
      this.intervalExchnge = setInterval(() => {
        this.getPortfolioData();
      }, 1000);
    } else {
      clearInterval(this.intervalExchnge);
    }
  }

  componentWillUnmount() {
    clearInterval(this.intervalExchnge);
  }

  getData() {
    const { user } = this.props.auth;
    const contestId = this.props.contestId;
    axios
      .post(baseUrl + "api/profile-data", {}, config)
      .then((res) => {
        this.setState({
          winningamount: res.data.data.winningamount,
          bonus: res.data.data.bonus,
          balance: res.data.data.balance,
          Rebalance: res.data.data.Rebalance,
          videoStatus: res.data.data.videoStatus,
        });
      })
      .catch();
    var profitLoass = (
      ((this.state.openBuyOrderValue +
        this.props.portfoliototal +
        this.state.virtualFund -
        this.props.virtualFundassign) *
        100) /
      this.props.virtualFundassign
    ).toFixed(2);
  }
  onLogoutClick = (e) => {
    e.preventDefault();
    this.props.logoutUser();
    window.location = callLogoutUrl;
  };
  openModal() {
    this.setState({ modalIsOpen: true });
  }
  openTimerModal() {
    this.setState({ modalIstimerOpen: true });
  }
  afterOpenModal() {
    // references are now sync'd and can be accessed.
    this.subtitle.style.color = "#f00";
  }

  closeModal() {
    this.setState({ modalIsOpen: true });
  }
  showTimerCounterHtml = () => {
    if (this.state.contestId != "" && this.state.contestId != undefined) {
      if (!isNaN(this.state.days)) {
        return (
          <li>
            <span className="header_timer">
              {this.state.days}
              <span>Day </span>
              {this.state.hours}
              <span>Hr </span>
              {this.state.minutes}
              <span>Min </span>
              {this.state.seconds}
              <span>Sec </span>
              Left
            </span>
          </li>
        );
      }
    }
  };
  tabClick(tabType) {
    const { user } = this.props.auth;
    window.webengage.track("Live Contest Category Viewed", {
      "Category Name": tabType,
      "Phone number": user.mobile,
      Name: user.name,
    });
    // const data={
    //     'Category Name':tabType,
    //     'Phone number':user.mobile,
    //     'Name':user.name
    // };
    // console.log("tempData==",data);
  }
  render() {
    if (this.state.videoStatus != "") {
      var videom = this.state.videoStatus;
    }
    var totalTemp =
      this.state.openBuyOrderValue +
      this.state.portfoliototal +
      this.state.virtualFund;
    totalTemp = totalTemp - this.props.virtualFundassign;

    const virtualFundassignCal =
      (totalTemp * 100) / this.props.virtualFundassign;
    var finalVertualFund = "";
    if (!isNaN(virtualFundassignCal)) {
      finalVertualFund = virtualFundassignCal.toFixed(3) + "%";
    } else {
      finalVertualFund = "0.00%";
    }

    const { user } = this.props.auth;

    return (
      <>
        {this.state.appview && (
          <nav className="navbar navbar-expand-lg home_nav nav-scroll2">
            <div className="container ">
              {/* <!-- logo --> */}
              <a className="navbar-brand" href={baseurlMain}>
                <img src="/img/logo.svg" alt="header-Logo" />
              </a>

              <div className="collapse navbar-collapse" id="navbarText2">
                <ul className="navbar-nav  line ml-auto mr-auto">
                  <li className="nav-item">
                    <a
                      href={
                        source !== "" && theme !== ""
                          ? "/dashboard" + this.state.urltemp
                          : "/dashboard"
                      }
                      className="nav-link"
                      onClick={() => this.tabClick("Dashboard")}
                    >
                      Dashboard
                    </a>
                  </li>
                  {/* <li className="nav-item">
                <a href={(source!=='' && theme !=="")?"/contest"+this.state.urltemp:"/contest"} className="nav-link" onClick={() => this.tabClick('Contest')}>Contest</a>   
                </li> */}
                  {/* <li className="nav-item">
                <a href={(source!=='' && theme !=="")?"/winningHistoryTable"+this.state.urltemp:"/winningHistoryTable"} className="nav-link" onClick={() => this.tabClick('Winning Contest')}>Winning Contest</a>
                   
                </li> */}
                  {this.state.account === "1" && (
                    <li className="nav-item">
                      <a
                        href={
                          source !== "" && theme !== ""
                            ? "/account" + this.state.urltemp
                            : "/account"
                        }
                        className="nav-link"
                        onClick={() => this.tabClick("Account")}
                      >
                        Points Wallet
                      </a>
                    </li>
                  )}
                  {/* {this.state.account ==='1' && */}
                  <li className="nav-item">
                    <a
                      href={
                        source !== "" && theme !== ""
                          ? "/addCash" + this.state.urltemp
                          : "/addCash"
                      }
                      className="nav-link"
                      onClick={() => this.tabClick("addCash")}
                    >
                      Cash Wallet
                    </a>
                  </li>
                  {/* } */}
                  {/* {this.state.transaction ==='1' && */}
                  <li className="nav-item">
                    <a
                      href={
                        source !== "" && theme !== ""
                          ? "/transaction-history" + this.state.urltemp
                          : "/transaction-history"
                      }
                      className="nav-link"
                      onClick={() => this.tabClick("transaction-history")}
                    >
                      Transaction History
                    </a>
                  </li>
                  {/* } */}
                  {this.state.transaction === "1" && (
                    <li className="nav-item">
                      <a
                        href={
                          source !== "" && theme !== ""
                            ? "/withdrawal" + this.state.urltemp
                            : "/withdrawal"
                        }
                        className="nav-link"
                        onClick={() => this.tabClick("withdrawal")}
                      >
                        Withdrawal
                      </a>
                    </li>
                  )}
                  <li className="nav-item">
                    <a
                      href={
                        source !== "" && theme !== ""
                          ? "/ledger" + this.state.urltemp
                          : "/ledger"
                      }
                      className="nav-link"
                      onClick={() => this.tabClick("ledger")}
                    >
                      Ledger
                    </a>
                  </li>
                </ul>
              </div>
              <div className="right_menu ">
                {this.state.contestType != "price" &&
                  this.state.contestType != "coin" && (
                    <>
                      <li className="renone portfolio gain">
                        {this.state.contestId && this.state.ex_symbol && (
                          <span>
                            Portfolio Value:
                            {this.props.virtualFundassign <
                              this.state.userPortfolioAmt && (
                              <span className="man_color">
                                &nbsp;{this.state.userPortfolioAmt.toFixed(2)}
                              </span>
                            )}
                            {this.props.virtualFundassign >=
                              this.state.userPortfolioAmt && (
                              <span className="text-danger">
                                {this.state.userPortfolioAmt.toFixed(2)}
                              </span>
                            )}
                          </span>
                        )}
                      </li>
                      <li className="renone gain-text">
                        {this.state.contestId && this.state.ex_symbol && (
                          <span>
                            Gain:
                            {this.state.userPortfolioPercent >= "0" && (
                              <span className="man_color">
                                {" "}
                                {this.state.userPortfolioPercent}
                              </span>
                            )}
                            {this.state.userPortfolioPercent < "0" && (
                              <span className="text-danger">
                                {" "}
                                {this.state.userPortfolioPercent}
                              </span>
                            )}
                          </span>
                        )}
                      </li>
                    </>
                  )}
                <li className="nav-item position_relitive">
                  <a className="btn" href={baseurlMain}>
                    <button className="btn" id="dropdownMenuButton">
                      <i className="las la-home"></i>
                    </button>
                  </a>

                  {/* <li className="nav-item position_relitive">
                         <button  className="btn" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className="las la-home"></i>
                        </button>             */}
                  <div
                    className="dropdown-menu logout_drop p-0 pt-2"
                    aria-labelledby="dropdownMenuButton"
                  >
                    {/* <a className="dropdown-item" href="#"> 
                        <i className="las la-user"></i>Profile & Account</a> */}

                    {/* <a className="dropdown-item" href="#" onClick={this.onLogoutClick}><i className="las la-file-import"></i> Sign Out</a>
                     */}
                    <div className="downloadApp">
                      Download
                      <br />
                      3verse App
                      <a
                        target="_blank"
                        className="app_lionk app_lionk1"
                        href="https://play.google.com/store/apps/details?id=com.ticker.android.3verse"
                      ></a>
                      <a
                        target="_blank"
                        className="app_lionk app_lionk2"
                        href="https://apps.apple.com/in/app/3verse/id1587674775"
                      ></a>
                    </div>
                  </div>
                </li>
              </div>
              <button
                className="navbar-toggler collapsed"
                type="button"
                data-toggle="collapse"
                data-target="#navbarText2"
              >
                <span className="icon-bar">
                  <i className="las la-times"></i>
                </span>
              </button>
            </div>
          </nav>
        )}
        {this.state.navShow && (
          <div
            className="right_menu right_menu2"
            style={{
              display: "block",
            }}
          >
            {this.state.contestType != "price" &&
              this.state.contestType != "coin" && (
                <>
                  <li>
                    {this.state.contestId && this.state.ex_symbol && (
                      <span>
                        {" "}
                        Portfolio Value:{" "}
                        <span className="man_color">
                          {this.state.userPortfolioAmt.toFixed(2)}
                        </span>{" "}
                      </span>
                    )}
                  </li>
                  <li>
                    {this.state.contestId && this.state.ex_symbol && (
                      <span>
                        Gain:
                        {this.state.userPortfolioPercent >= "0" && (
                          <span className="man_color">
                            {" "}
                            {this.state.userPortfolioPercent}
                          </span>
                        )}
                        {this.state.userPortfolioPercent < "0" && (
                          <span className="text-danger">
                            {" "}
                            {this.state.userPortfolioPercent}
                          </span>
                        )}
                      </span>
                    )}
                  </li>
                </>
              )}
          </div>
        )}

        {videom != "verify" && (
          <Modal
            isOpen={this.state.modalIsOpen}
            onAfterOpen={this.afterOpenModal}
            onRequestClose={this.closeModal}
            style={customStyles}
            contentLabel="Example Modal"
          >
            <h2 ref={(subtitle) => (this.subtitle = subtitle)}>
              Verified Your KYC
            </h2>

            <a href="/kyc" className="click-here">
              {" "}
              Click Here
            </a>
          </Modal>
        )}

        {this.state.modalOnOff == "1" && this.state.contestId != undefined && (
          <div className="man_div">
            <div className="auto_box">
              <div className="white_box tc">
                <img src="/img/time-out.gif" />
                <br />
                <br />
                <h4>Time Out</h4>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

Navbar.propTypes = {
  logoutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(withRouter(Navbar));
